/**
 * Legal document version tracking.
 *
 * CURRENT_TERMS_VERSION — bump whenever Terms or Privacy content changes.
 * Content hashes — CI enforcement: if page content changes but hashes don't,
 * the termsVersion test fails, reminding you to bump the version + hashes.
 *
 * To get new hashes after editing terms/privacy pages, run the web test suite
 * and copy the expected hash from the failure message.
 */
// NOTE: CURRENT_TERMS_VERSION intentionally NOT bumped for the July 2026 privacy
// edit (added a personnel-access disclosure). We decided that clarifying change
// does not warrant forcing all users to re-consent, so only the content hash is
// updated. Bump the version only for changes that should re-prompt users.
export const CURRENT_TERMS_VERSION = "2026-05-10";
export const TERMS_CONTENT_HASH = "43fdfeed428250b4";
export const PRIVACY_CONTENT_HASH = "4c6b758be33256a2";
/**
 * Whether a user must (re)accept the terms. MONOTONIC: true only when they have
 * never accepted, or accepted a version strictly OLDER than the current one.
 *
 * We deliberately do NOT use strict `!==`. Version strings are baked into each
 * build, so a user on a stale bundle (an old cached PWA or an outdated native
 * build) with a different CURRENT_TERMS_VERSION would ping-pong forever: each
 * client overwrites the other's accepted version with its own constant, and the
 * newer build keeps seeing a mismatch and re-prompting. Comparing "older than"
 * means a client never forces re-consent on someone who already accepted the
 * current or a newer version, which breaks the loop.
 *
 * Version strings are ISO dates (YYYY-MM-DD), so lexicographic < is chronological.
 * Keep them in that format for this comparison to hold.
 */
export function needsTermsReconsent(accepted) {
    return !accepted || accepted < CURRENT_TERMS_VERSION;
}
